import React from 'react';
import PopUpPanel from '../PopUpPanel/PopUpPanel';

const navigateToIcast2 = () => {
  window.open('https://www.campaignstudio.tv', '_blank');
}

const MoveToIcast2Popup = ({ onClose }) => {
  return (
    <PopUpPanel isOpen={true} closePanelFunc={onClose} wide={true}>
        <h2>ICAST 2.0 Now Available</h2>
        <p>All new campaigns should now be set up using ICAST 2.0.</p>
        <p><a href="https://www.campaignstudio.tv" target="_blank" rel="noopener noreferrer">https://www.campaignstudio.tv</a></p>
        <p>Depending on your email address or Twitch handle, you may be able to gain access immediately, however, if you have any trouble gaining access, please contact Jason Latorre (@jasonlat) and Caro Negri (@ncarlyn) on Slack.</p>
        <button className='standard-button no-bottom-margin' onClick={navigateToIcast2}>
            Try ICAST 2.0 Today
        </button>
    </PopUpPanel>
  );
};

export default MoveToIcast2Popup;
